

jQuery(function ($) {
    let currentPage = 1;
    let filteredQuery = product_loadmore_params.posts || {};

    // ✅ Product Filter Submission
    $('#filter_products').submit(function (event) {

        event.preventDefault();
        console.log('Filter clicked');

        let formData = $('#filter_products').serialize();

        $.ajax({
            url: product_loadmore_params.ajaxurl,
            data: formData,
            dataType: 'json',
            type: 'POST',
            beforeSend: function () {
                $('#productpage__loadmore').text('Filtering...');
            },
            success: function (data) {
                
                console.log("AJAX Success Data:", data);

                $('#productpage__list').remove();

                currentPage = 1;
                product_loadmore_params.max_page = data.max_page;

                filteredQuery = data.posts;
                product_loadmore_params.posts = filteredQuery;

                console.log('Found posts ---> ' + data.data.found_posts);
                console.log('Max page ---> ' + data.data.max_page);
                console.log(data.data.content);

                $('#productpage__list').html(data.data.content);

                if (data.data.max_page < 2) {
                    $('#productpage__loadmore').hide();
                } else {
                    $('#productpage__loadmore').show().text('View More');
                }

                $("input[name='s']").val(""); // Clear search input
            },
            error: function (xhr, status, error) {
                console.log("AJAX Error:", error);
                $('#productpage__list').html('<p>Something went wrong. Please try again.</p>');
            }
        });

        return false;
    });

    // ✅ Load More Products
    $('#productpage__loadmore').click(function (event) {

        event.preventDefault();
        console.log("Load More clicked");

        currentPage++;

        $.ajax({
            url: product_loadmore_params.ajaxurl,
            data: {
                'action': 'productloadmore',
                'query': filteredQuery || product_loadmore_params.posts,
                'page': currentPage,
                'producemain': $("select[name='producemain']").val()
            },
            dataType: 'json',
            type: 'POST',
            beforeSend: function () {
                $('#productpage__loadmore').text('Loading...');
            },
            success: function (response) {

                console.log("AJAX Load More Response:", response);

                if (response.success && response.data.content) {

                    $('#productpage__list').append(response.data.content);
                    console.log('Current page ---> ' + currentPage);
                    console.log('Max page ---> ' + response.data.max_page);

                    if (currentPage >= response.data.max_page) {
                        console.log('No more pages left');
                        $('#productpage__loadmore').hide();
                    } else {
                        $('#productpage__loadmore').text('View More');
                    }
                } else {
                    console.log("No more posts to load.");
                    $('#productpage__loadmore').hide();
                }
            },
            error: function (xhr, status, error) {
                console.log("AJAX Load More Error:", error);
            }
        });

        return false;
    });
});
